import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {logos} from './config.js'

const SharedBrandLogo = ({alt}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const site = config.get('TENANT')
  const appName = config.get('APP_NAME')

  const defaultAlt = i18n.t(`BRAND_LOGO.ALT_TEXT_DEFAULT_${appName}`)

  const altText = alt ?? defaultAlt

  return <img src={`data:image/svg+xml;base64,${logos[site]}`} alt={altText} />
}

SharedBrandLogo.displayName = 'SharedBrandLogo'
SharedBrandLogo.propTypes = {
  alt: PropTypes.string
}

export default SharedBrandLogo
